import produce from "immer"
import { update } from "lodash-es"
import setObj from "lodash-es/set"
import { mountStoreDevtool } from "simple-zustand-devtools"
import create from "zustand"

export type StateType = {
  id?: string
  kind?: any
  provider?: any
  isProgrammatic?: boolean
  name?: string
  title?: string
  body?: string
  dataSource?: any
  extraFields?: {
    image?: string
    data?: {
      action: {
        name: "route"
        value: {
          type: any
          id: any
        }
      }
    }
  }
  providerVariables?: { key: string; value: string | number }[]
  dataVariables?: { key: string; value: string | number }[]
}
export type NotificationTemplateStoreType = {
  data: StateType
  setData: (path: string, value: any) => void
  setOutputVariable: (variable: any) => void
  resetData: () => void
  removeListItem: (
    key: string,
    index: number,
    updateLastSaved?: boolean
  ) => void
  addListItem: (key: string, item: any) => void
  initializeState: (state: StateType) => void
}
const useNotificationTemplateStore = create<NotificationTemplateStoreType>(
  set => ({
    data: {
      extraFields: {},
    },
    setData(path, value) {
      set(
        produce((draft: NotificationTemplateStoreType) => {
          if (path === "kind") {
            draft.data.provider = null
            if (value !== "email" && draft.data.body) {
              draft.data.body = new DOMParser().parseFromString(
                draft.data.body,
                "text/html"
              ).documentElement.textContent
            }
          }
          setObj(draft.data, path, value)
        })
      )
    },
    setOutputVariable(variable) {
      set(
        produce((draft: NotificationTemplateStoreType) => {
          if (draft.data.body.startsWith("<p>")) {
            const parser = new DOMParser()
            const content = parser.parseFromString(draft.data.body, "text/html")
            const paragraph = content.getElementsByTagName("p")?.[0]
            paragraph.appendChild(document.createTextNode(variable.key))
            draft.data.body = content.body.innerHTML
          } else {
            draft.data.body += variable.key
          }
        })
      )
    },
    resetData() {
      set(
        produce((draft: NotificationTemplateStoreType) => {
          draft.data = {
            id: draft.data.id,
          }
        })
      )
    },
    addListItem(key: string, item: any) {
      set(
        produce((store: NotificationTemplateStoreType) => {
          update(store.data, key, val => (val?.length ? val : []).concat(item))
        })
      )
    },
    removeListItem(key, index) {
      set(
        produce((store: NotificationTemplateStoreType) => {
          update(store.data, key, val =>
            val.filter((_: any, i: number) => i !== index)
          )
        })
      )
    },
    initializeState(state) {
      set(
        produce((store: NotificationTemplateStoreType) => {
          store.data = state
        })
      )
    },
  })
)
if (process.env.NODE_ENV === "development") {
  mountStoreDevtool("NotificationTemplateStore", useNotificationTemplateStore)
}
export default useNotificationTemplateStore
